import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import Projeto from "features/projetos/models/Projeto";

export async function findCodigoProjeto(codigoProjeto?: string):
  Promise<IResponse<boolean>> {
  const result = await axios.get(`/Projetos/Existe/${codigoProjeto}`);
  return { data: result.status === 200 };
}